(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
'use strict';

var _header = require('./public/components/header.js');

var _share_button = require('./public/components/share_button.js');

var _share_button2 = _interopRequireDefault(_share_button);

var _scrollTop = require('./public/components/scrollTop.js');

var _video_smoke = require('./public/components/video_smoke.js');

var _video_smoke2 = _interopRequireDefault(_video_smoke);

var _slider_contained_one_column = require('./public/sections/slider_contained_one_column.js');

var _slider_contained_one_column2 = _interopRequireDefault(_slider_contained_one_column);

var _slider_products_init = require('./public/sections/slider_products_init.js');

var _slider_products_init2 = _interopRequireDefault(_slider_products_init);

var _products = require('./public/pages/products.js');

var _products2 = _interopRequireDefault(_products);

var _scotcheggclub = require('./public/pages/scotcheggclub.js');

var _scotcheggclub2 = _interopRequireDefault(_scotcheggclub);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function init() {
				(0, _header.header_menu_init)($);
				(0, _share_button2.default)($);
				(0, _video_smoke2.default)($);
				(0, _slider_contained_one_column2.default)($);
				(0, _scrollTop.scrollTop)($);
				(0, _scrollTop.showTop)($);
				if ($(".scotch-egg-club").length) {
					(0, _scotcheggclub2.default)($);
				}
			},
			finalize: function finalize() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		// Home page
		'home': {
			init: function init() {},
			finalize: function finalize() {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		// About us page, note the change from about-us to about_us.
		'about_us': {
			init: function init() {
				// JavaScript to be fired on the about us page
			}
		},
		// Products/Emporium page.
		'products': {
			init: function init() {
				(0, _products2.default)($);
				(0, _slider_products_init2.default)($);
			}

			// The routing fires all common scripts, followed by the page specific scripts.
			// Add additional events for more control over timing e.g. a finalize event
		} };var UTIL = {
		fire: function fire(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = funcname === undefined ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function loadEvents() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}

		// Load Events
	};$(document).ready(UTIL.loadEvents);

	function click_handler(e) {
		var href = $(this).attr('href');
		var targetLocation = href.split('#')[0].replace(/(^\w+:|^)\/\//, '').replace(/\/$/, "");
		var targetdrink = href.split('#')[1];

		if (targetdrink) {
			var currentLocation = $(location).attr('href').split('#')[0].replace(/(^\w+:|^)\/\//, '').replace(/\/$/, "");

			if (currentLocation == targetLocation) {
				e.preventDefault();
				e.stopPropagation();

				'#' + targetdrink;

				$('html, body').animate({
					scrollTop: $('#' + targetdrink).offset().top - 62
				}, 1000);

				document.location.href = '#' + targetdrink;
				return false; // fix the flicker on click
			}
		}
	}

	$('.menu-item a').click(click_handler);

	$('.no-click > a').click(function (e) {
		e.preventDefault();
		e.stopPropagation();
		return false;
	});

	// Equalize Function for Homepage Feature Columns
	$.fn.equalize = function () {

		var maxHeight = 0;

		// Remove the 'min-height' inline style (if there is one).
		this.each(function () {
			$(this).css("min-height", '');
		});

		// Calculate the tallest height
		this.each(function () {
			var $this = $(this);
			// console.log( $this.attr( 'class') + ': ' + $this.innerHeight() );
			if ($this.innerHeight() > maxHeight) {
				maxHeight = $this.innerHeight() + 2;
			}
		});

		// Return the element's 'min-height'
		return this.each(function () {
			var styles = {
				// border: "#f00 solid 1px",
				minHeight: maxHeight
			};
			$(this).css(styles);
		});
	};

	$(window).on('resize load', function () {
		$('.home-cta .section__item.tile_column .component__header').equalize();
		$('.archive-ambassadors .section__item.tile_column .component__header').equalize();
		$('.section__item.tile_column .component__paragraph').equalize();
	});
})(jQuery); // Fully reference jQuery after this point.
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/fake_f85451b0.js","/")
},{"./public/components/header.js":2,"./public/components/scrollTop.js":3,"./public/components/share_button.js":4,"./public/components/video_smoke.js":5,"./public/pages/products.js":6,"./public/pages/scotcheggclub.js":7,"./public/sections/slider_contained_one_column.js":8,"./public/sections/slider_products_init.js":9,"buffer":11,"rH1JPG":13}],2:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var burgerOpen = false;

var navButton = document.getElementById("nav-menu-button"),
    navUl = document.getElementsByClassName("menu grid-equalHeight"),
    navWrap = document.getElementsByClassName("menu-primary-navigation-container");

var mobileMenuOpen = false;

var mobileCEPMenuOpen = false;

function toggleMobileMenu() {
	if (mobileMenuOpen) {
		navUl[0].classList.add("hide-ul"), navWrap[0].classList.add("hide-nav-wrap");
		mobileMenuOpen = false;
	} else {
		navUl[0].classList.remove("hide-ul"), navWrap[0].classList.remove("hide-nav-wrap");
		mobileMenuOpen = true;
	}
	if (mobileCEPMenuOpen) {
		jQuery('#mobile-menu-icon').toggleClass("menu-icon__open menu-icon__close");
		jQuery('#spotlight-menu-wrapper-mb').fadeToggle();
		mobileCEPMenuOpen = false;
	}
}
//	add a class to the primary nav ul, in order to toggle hide the mobile nav via the burger


function header_menu_init($) {

	$('.menu-primary-navigation-container').addClass('hide-nav-wrap');
	//	add a class to the nav container, in order to hide the container on mobile until opened

	$('.menu-primary-navigation-container .menu').addClass('grid-equalHeight hide-ul');
	//	add a class to the primary nav ul, in order to hide the nav in mobile view by default

	if (navButton == null) {
		return;
	}

	navButton.onclick = toggleMobileMenu;
	//	remove the hide-ul class once the menu button is click in mobile view

	$('.burger').click(function () {
		if (burgerOpen) {
			$(this).removeClass('open');
			burgerOpen = false;
		} else {
			$(this).addClass('open');
			burgerOpen = true;
		}
	});

	$(document).on('click', '#mobile-menu-icon', function () {
		if (mobileMenuOpen) {
			$('#nav-menu-button').click();
		}
		if (mobileCEPMenuOpen) {
			mobileCEPMenuOpen = false;
		} else {
			mobileCEPMenuOpen = true;
		}
	});

	$('.menu-item-has-children').addClass('has-subnav');
	//	add new has-subnav class to li's with subnav ul's

	if ($(".nav__item__text").length === 0) {
		$('.menu-primary-navigation-container .menu-item a').wrapInner('<span class="nav__item__text"></span>');
	}
	//	add a span to wrap the text in the header nav items

	var add_toggle_links = function add_toggle_links() {
		if ($('.menu-link').is(":visible")) {
			if ($(".toggle-link").length > 0) {} else {
				$('.has-subnav > a').after('<span class="toggle-link"></span>');
				$('.toggle-link').click(function (e) {
					var $this = $(this);
					if ($this.hasClass('active')) {
						$this.removeClass('active').siblings('ul').removeClass('active').parent('li').removeClass('active');
					} else {
						$('.toggle-link, li.has-subnav, ul.sub-menu').removeClass('active');
						$this.addClass('active').siblings('ul').addClass('active').parent('li').addClass('active');
					}
				});
			}
		} else {
			$('.toggle-link').empty();
		}
	};
	//	add additional span element if nav-items have sub-nav items, if the burger is visible


	add_toggle_links();
	$(window).bind("resize", add_toggle_links);
	//	only run this code if the window has been resized
}

exports.header_menu_init = header_menu_init;
exports.toggleMobileMenu = toggleMobileMenu;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/public/components/header.js","/public/components")
},{"buffer":11,"rH1JPG":13}],3:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

function scrollTop($) {
	var root = $('html, body');
	var top = $('html').offset().top;

	$('.back-to-top a').on('click', function (e) {
		e.preventDefault();

		$(root).stop().animate({
			'scrollTop': top
		}, 900, 'swing', 0);
	});
}

function showTop($) {
	$('.back-to-top').hide();
	$(window).scroll(function () {
		var Top = 400;
		if ($(this).scrollTop() >= Top) {
			$('.back-to-top').show();
		} else {
			$('.back-to-top').hide();
		}
	});
}

exports.scrollTop = scrollTop;
exports.showTop = showTop;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNjcm9sbFRvcC5qcyJdLCJuYW1lcyI6WyJyb290IiwiJCIsInRvcCIsImUiLCJUb3AiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUNBLFNBQUEsU0FBQSxDQUFBLENBQUEsRUFBc0I7QUFDckIsS0FBSUEsT0FBT0MsRUFBWCxZQUFXQSxDQUFYO0FBQ0EsS0FBSUMsTUFBTUQsRUFBQUEsTUFBQUEsRUFBQUEsTUFBQUEsR0FBVixHQUFBOztBQUVBQSxHQUFBQSxnQkFBQUEsRUFBQUEsRUFBQUEsQ0FBQUEsT0FBQUEsRUFBK0IsVUFBQSxDQUFBLEVBQWE7QUFDM0NFLElBQUFBLGNBQUFBOztBQUVBRixJQUFBQSxJQUFBQSxFQUFBQSxJQUFBQSxHQUFBQSxPQUFBQSxDQUF1QjtBQUN0QixnQkFBYUM7QUFEUyxHQUF2QkQsRUFBQUEsR0FBQUEsRUFBQUEsT0FBQUEsRUFBQUEsQ0FBQUE7QUFIREEsRUFBQUE7QUFPQTs7QUFFRCxTQUFBLE9BQUEsQ0FBQSxDQUFBLEVBQW9CO0FBQ25CQSxHQUFBQSxjQUFBQSxFQUFBQSxJQUFBQTtBQUNBQSxHQUFBQSxNQUFBQSxFQUFBQSxNQUFBQSxDQUFpQixZQUFVO0FBQzFCLE1BQUlHLE1BQUosR0FBQTtBQUNBLE1BQUdILEVBQUFBLElBQUFBLEVBQUFBLFNBQUFBLE1BQUgsR0FBQSxFQUE0QjtBQUMzQkEsS0FBQUEsY0FBQUEsRUFBQUEsSUFBQUE7QUFERCxHQUFBLE1BRU87QUFDTkEsS0FBQUEsY0FBQUEsRUFBQUEsSUFBQUE7QUFDQTtBQU5GQSxFQUFBQTtBQVFBOztRQUVELFMsR0FBQSxTO1FBQUEsTyxHQUFBLE8iLCJzb3VyY2VzQ29udGVudCI6WyJcbmZ1bmN0aW9uIHNjcm9sbFRvcCgkKSB7XG5cdHZhciByb290ID0gJCgnaHRtbCwgYm9keScpO1xuXHR2YXIgdG9wID0gJCgnaHRtbCcpLm9mZnNldCgpLnRvcDtcblxuXHQkKCcuYmFjay10by10b3AgYScpLm9uKCdjbGljaycsZnVuY3Rpb24gKGUpIHtcblx0XHRlLnByZXZlbnREZWZhdWx0KCk7XG5cblx0XHQkKHJvb3QpLnN0b3AoKS5hbmltYXRlKHtcblx0XHRcdCdzY3JvbGxUb3AnOiB0b3Bcblx0XHR9LCA5MDAsICdzd2luZycsIDApO1xuXHR9KTtcbn1cblxuZnVuY3Rpb24gc2hvd1RvcCgkKSB7XG5cdCQoJy5iYWNrLXRvLXRvcCcpLmhpZGUoKTtcblx0JCh3aW5kb3cpLnNjcm9sbChmdW5jdGlvbigpe1xuXHRcdHZhciBUb3AgPSA0MDA7XG5cdFx0aWYoJCh0aGlzKS5zY3JvbGxUb3AoKT49VG9wKXtcblx0XHRcdCQoJy5iYWNrLXRvLXRvcCcpLnNob3coKTtcblx0XHR9IGVsc2Uge1xuXHRcdFx0JCgnLmJhY2stdG8tdG9wJykuaGlkZSgpO1xuXHRcdH1cblx0fSk7XG59XG5cbmV4cG9ydCB7XG5cdHNjcm9sbFRvcCxcblx0c2hvd1RvcFxufVxuIl19
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/public/components/scrollTop.js","/public/components")
},{"buffer":11,"rH1JPG":13}],4:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = share_button_init;
function share_button_init($) {
	$('.share__buttons .cta').click(function (event) {
		if (!$(event.currentTarget).hasClass('open')) {
			$(event.currentTarget).addClass('open');
			$(event.currentTarget).parent().addClass('open');
			$(event.currentTarget).parent().parent().parent().find('.share__buttons').addClass('open');
		} else {
			$(event.currentTarget).removeClass('open');
			$(event.currentTarget).parent().removeClass('open');
			$(event.currentTarget).parent().parent().parent().find('.share__buttons').removeClass('open');
		}
		event.preventDefault();
	});
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNoYXJlX2J1dHRvbi5qcyJdLCJuYW1lcyI6WyIkIiwiZXZlbnQiXSwibWFwcGluZ3MiOiI7Ozs7O2tCQUFlLGlCO0FBQUEsU0FBQSxpQkFBQSxDQUFBLENBQUEsRUFBOEI7QUFDNUNBLEdBQUFBLHNCQUFBQSxFQUFBQSxLQUFBQSxDQUFpQyxpQkFBVztBQUMzQyxNQUFLLENBQUNBLEVBQUVDLE1BQUZELGFBQUFBLEVBQUFBLFFBQUFBLENBQU4sTUFBTUEsQ0FBTixFQUErQztBQUM5Q0EsS0FBRUMsTUFBRkQsYUFBQUEsRUFBQUEsUUFBQUEsQ0FBQUEsTUFBQUE7QUFDQUEsS0FBRUMsTUFBRkQsYUFBQUEsRUFBQUEsTUFBQUEsR0FBQUEsUUFBQUEsQ0FBQUEsTUFBQUE7QUFDQUEsS0FBRUMsTUFBRkQsYUFBQUEsRUFBQUEsTUFBQUEsR0FBQUEsTUFBQUEsR0FBQUEsTUFBQUEsR0FBQUEsSUFBQUEsQ0FBQUEsaUJBQUFBLEVBQUFBLFFBQUFBLENBQUFBLE1BQUFBO0FBSEQsR0FBQSxNQUlPO0FBQ05BLEtBQUVDLE1BQUZELGFBQUFBLEVBQUFBLFdBQUFBLENBQUFBLE1BQUFBO0FBQ0FBLEtBQUVDLE1BQUZELGFBQUFBLEVBQUFBLE1BQUFBLEdBQUFBLFdBQUFBLENBQUFBLE1BQUFBO0FBQ0FBLEtBQUVDLE1BQUZELGFBQUFBLEVBQUFBLE1BQUFBLEdBQUFBLE1BQUFBLEdBQUFBLE1BQUFBLEdBQUFBLElBQUFBLENBQUFBLGlCQUFBQSxFQUFBQSxXQUFBQSxDQUFBQSxNQUFBQTtBQUNBO0FBQ0RDLFFBQUFBLGNBQUFBO0FBVkRELEVBQUFBO0FBWUEiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzaGFyZV9idXR0b25faW5pdCgkKSB7XG5cdCQoJy5zaGFyZV9fYnV0dG9ucyAuY3RhJykuY2xpY2soIChldmVudCkgPT4ge1xuXHRcdGlmICggISQoZXZlbnQuY3VycmVudFRhcmdldCkuaGFzQ2xhc3MoJ29wZW4nKSkge1xuXHRcdFx0JChldmVudC5jdXJyZW50VGFyZ2V0KS5hZGRDbGFzcygnb3BlbicpO1xuXHRcdFx0JChldmVudC5jdXJyZW50VGFyZ2V0KS5wYXJlbnQoKS5hZGRDbGFzcygnb3BlbicpO1xuXHRcdFx0JChldmVudC5jdXJyZW50VGFyZ2V0KS5wYXJlbnQoKS5wYXJlbnQoKS5wYXJlbnQoKS5maW5kKCcuc2hhcmVfX2J1dHRvbnMnKS5hZGRDbGFzcygnb3BlbicpO1xuXHRcdH0gZWxzZSB7XG5cdFx0XHQkKGV2ZW50LmN1cnJlbnRUYXJnZXQpLnJlbW92ZUNsYXNzKCdvcGVuJyk7XG5cdFx0XHQkKGV2ZW50LmN1cnJlbnRUYXJnZXQpLnBhcmVudCgpLnJlbW92ZUNsYXNzKCdvcGVuJyk7XG5cdFx0XHQkKGV2ZW50LmN1cnJlbnRUYXJnZXQpLnBhcmVudCgpLnBhcmVudCgpLnBhcmVudCgpLmZpbmQoJy5zaGFyZV9fYnV0dG9ucycpLnJlbW92ZUNsYXNzKCdvcGVuJyk7XG5cdFx0fVxuXHRcdGV2ZW50LnByZXZlbnREZWZhdWx0KCk7XG5cdH0pXG59Il19
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/public/components/share_button.js","/public/components")
},{"buffer":11,"rH1JPG":13}],5:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = video_smoke_init;
function video_smoke_init($) {
	$('#smokeVideo').seeThru({
		start: 'autoplay',
		end: 'loop',
		width: 640,
		height: 360
	});
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInZpZGVvX3Ntb2tlLmpzIl0sIm5hbWVzIjpbIiQiLCJzdGFydCIsImVuZCIsIndpZHRoIiwiaGVpZ2h0Il0sIm1hcHBpbmdzIjoiOzs7OztrQkFBZSxnQjtBQUFBLFNBQUEsZ0JBQUEsQ0FBQSxDQUFBLEVBQTZCO0FBQzNDQSxHQUFBQSxhQUFBQSxFQUFBQSxPQUFBQSxDQUF5QjtBQUN4QkMsU0FEd0IsVUFBQTtBQUV4QkMsT0FGd0IsTUFBQTtBQUd4QkMsU0FId0IsR0FBQTtBQUl4QkMsVUFBUTtBQUpnQixFQUF6Qko7QUFNQSIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHZpZGVvX3Ntb2tlX2luaXQoJCkge1xuXHQkKCcjc21va2VWaWRlbycpLnNlZVRocnUoe1xuXHRcdHN0YXJ0IDogJ2F1dG9wbGF5Jyxcblx0XHRlbmQgOiAnbG9vcCcsXG5cdFx0d2lkdGg6IDY0MCxcblx0XHRoZWlnaHQ6IDM2MFxuXHR9KVxufSJdfQ==
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/public/components/video_smoke.js","/public/components")
},{"buffer":11,"rH1JPG":13}],6:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = hover_effect_init;
function hover_effect_init($) {
	$(window).load(function () {

		var OverlayCanvas = document.createElement("canvas");
		document.body.appendChild(OverlayCanvas);
		OverlayCanvas.setAttribute("id", "overlay");
		OverlayCanvas.className = "highlight";

		var padding = 30; //Space around canvas
		//var animDelay = 250;
		var bodyRect;

		var divs = document.getElementsByClassName("product_canvas");

		for (var i = 0; i < divs.length; i++) {
			/*divs[i].addEventListener("click", function() {
   	event.preventDefault();
   	//openOverlay(this);
   }, true);*/

			divs[i].addEventListener("mouseenter", function () {
				openOverlay(this);
			}, true);

			divs[i].addEventListener("mouseleave", function (e) {
				if (window.overlayCanvas) closeOverlay.call(overlayCanvas);
			}, false);
		}

		function openOverlay(elem) {
			var loc = elem.getBoundingClientRect();
			bodyRect = document.body.getBoundingClientRect();
			var canvas = document.getElementById("overlay");
			canvas.width = document.body.clientWidth;
			canvas.height = document.body.clientHeight;
			var ctx = canvas.getContext("2d");
			ctx.fillRect(0, 0, canvas.width, canvas.height);

			var x = loc.left - padding;
			var y = loc.top - padding;
			var w = loc.width + padding * 2;
			var h = loc.height + padding * 2;
			var offset = loc.top - bodyRect.top;

			ctx.clearRect(Math.ceil(x - padding), Math.ceil(offset - padding), Math.ceil(w + padding * 2), Math.ceil(h + padding * 2));

			//var grd=ctx.createRadialGradient(loc.left+loc.width/2,loc.top+loc.height/2,0,loc.left+loc.width/2,loc.top+loc.height/2,loc.width);
			var grd = ctx.createRadialGradient(Math.ceil(x + w / 2), Math.ceil(offset + h / 2), 0, Math.ceil(x + w / 2), Math.ceil(offset + h / 2), Math.ceil(w / 2 + padding));
			grd.addColorStop(0, "transparent");
			grd.addColorStop(1, "black");

			ctx.fillStyle = grd;
			ctx.fillRect(Math.ceil(x - padding), Math.ceil(offset - padding), Math.ceil(w + padding * 2), Math.ceil(h + padding * 2));

			//document.body.appendChild(canvas);
			window.overlayCanvas = canvas;
			canvas.style.opacity = 0.75;
			canvas.onclick = closeOverlay;
		}

		function closeOverlay() {
			delete window.overlayCanvas;
			this.style.opacity = 0;
			var self = this;
			//setTimeout(function() {
			//self.parentNode.removeChild(self);
			var canvas = document.getElementById("overlay");
			//canvas.classList.remove("highlight");
			canvas.style.opacity = 0;
			canvas.width = 0;
			canvas.height = 0;
			//}, animDelay);
		}
	});
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/public/pages/products.js","/public/pages")
},{"buffer":11,"rH1JPG":13}],7:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
'use strict';

Object.defineProperty(exports, "__esModule", {
   value: true
});
exports.default = legal_link_init;
function legal_link_init($) {
   $(document).ready(function () {
      var scrollForMoreElement = document.querySelector('.scroll-for-more');
      var anchor = document.createElement('a');
      anchor.href = './terms-and-conditions/#generated-content';
      anchor.innerText = 'Beitrag nur mit Personen ab 18 Jahren.';
      anchor.target = '_blank';
      scrollForMoreElement.appendChild(anchor);
   });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNjb3RjaGVnZ2NsdWIuanMiXSwibmFtZXMiOlsiJCIsInNjcm9sbEZvck1vcmVFbGVtZW50IiwiZG9jdW1lbnQiLCJhbmNob3IiXSwibWFwcGluZ3MiOiI7Ozs7O2tCQUFlLGU7QUFBQSxTQUFBLGVBQUEsQ0FBQSxDQUFBLEVBQTRCO0FBQzFDQSxLQUFBQSxRQUFBQSxFQUFBQSxLQUFBQSxDQUFrQixZQUFVO0FBQ3pCLFVBQU1DLHVCQUF1QkMsU0FBQUEsYUFBQUEsQ0FBN0Isa0JBQTZCQSxDQUE3QjtBQUNBLFVBQU1DLFNBQVNELFNBQUFBLGFBQUFBLENBQWYsR0FBZUEsQ0FBZjtBQUNBQyxhQUFBQSxJQUFBQSxHQUFBQSwyQ0FBQUE7QUFDQUEsYUFBQUEsU0FBQUEsR0FBQUEsd0NBQUFBO0FBQ0FBLGFBQUFBLE1BQUFBLEdBQUFBLFFBQUFBO0FBQ0FGLDJCQUFBQSxXQUFBQSxDQUFBQSxNQUFBQTtBQU5IRCxJQUFBQTtBQVFBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gbGVnYWxfbGlua19pbml0KCQpIHtcblx0JChkb2N1bWVudCkucmVhZHkoZnVuY3Rpb24oKXtcbiAgICBjb25zdCBzY3JvbGxGb3JNb3JlRWxlbWVudCA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IoJy5zY3JvbGwtZm9yLW1vcmUnKTtcbiAgICBjb25zdCBhbmNob3IgPSBkb2N1bWVudC5jcmVhdGVFbGVtZW50KCdhJyk7XG4gICAgYW5jaG9yLmhyZWYgPSAnLi90ZXJtcy1hbmQtY29uZGl0aW9ucy8jZ2VuZXJhdGVkLWNvbnRlbnQnO1xuICAgIGFuY2hvci5pbm5lclRleHQgPSAnQmVpdHJhZyBudXIgbWl0IFBlcnNvbmVuIGFiIDE4IEphaHJlbi4nO1xuICAgIGFuY2hvci50YXJnZXQgPSAnX2JsYW5rJztcbiAgICBzY3JvbGxGb3JNb3JlRWxlbWVudC5hcHBlbmRDaGlsZChhbmNob3IpO1xuXHR9KTtcbn1cblxuIl19
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/public/pages/scotcheggclub.js","/public/pages")
},{"buffer":11,"rH1JPG":13}],8:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = slider_contained_one_column_init;
function slider_contained_one_column_init($) {
	$('.slick-slider .section__group').slick({
		dots: true,
		adaptiveHeight: true,
		autoplay: false,
		autoplaySpeed: 3100,
		pauseOnHover: false,
		speed: 750,
		fade: false,
		cssEase: 'ease-in-out',
		nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" role="button" style="display: block;"><i class="fa fa-chevron-right slick-arrow-icon slick-arrow-icon-next"></i></button>',
		prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Prev" role="button" style="display: block;"><i class="fa fa-chevron-left slick-arrow-icon slick-arrow-icon-prev"></i></button>',
		responsive: [{
			breakpoint: 568,
			settings: {
				appendArrows: '.section__item.home-slider-pagination'
			}
		}]
	});

	$('a[href$="#scroll-for-more"]').click(function (e) {
		var scroll_height = $(".scroll-for-more").height();
		$('html, body').animate({
			scrollTop: $(".scroll-for-more").offset().top + scroll_height
		}, 600);
		e.preventDefault();
	});
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/public/sections/slider_contained_one_column.js","/public/sections")
},{"buffer":11,"rH1JPG":13}],9:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = slider_products_init;
function slider_products_init($) {
	$(document).ready(function () {

		var $slick_slider = $('.slick-slider');
		var settings = {
			accessibility: true,
			dots: true,
			adaptiveHeight: true,
			autoplay: false,
			autoplaySpeed: 3100,
			pauseOnHover: false,
			speed: 750,
			fade: false,
			cssEase: 'ease-in-out',
			nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" role="button" style="display: block;"><i class="fa fa-chevron-right slick-arrow-icon slick-arrow-icon-next"></i></button>',
			prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Prev" role="button" style="display: block;"><i class="fa fa-chevron-left slick-arrow-icon slick-arrow-icon-prev"></i></button>'
		};
		if ($(window).width() < 768) {
			$slick_slider.slick(settings);
		}

		// reslick only if it's not slick()
		$(window).on('resize', function () {
			if ($(window).width() > 768) {
				if ($slick_slider.hasClass('slick-initialized')) {
					$slick_slider.slick('unslick');
				}
				return;
			}

			if (!$slick_slider.hasClass('slick-initialized')) {
				return $slick_slider.slick(settings);
			}
		});
	});
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/public/sections/slider_products_init.js","/public/sections")
},{"buffer":11,"rH1JPG":13}],10:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

;(function (exports) {
	'use strict';

  var Arr = (typeof Uint8Array !== 'undefined')
    ? Uint8Array
    : Array

	var PLUS   = '+'.charCodeAt(0)
	var SLASH  = '/'.charCodeAt(0)
	var NUMBER = '0'.charCodeAt(0)
	var LOWER  = 'a'.charCodeAt(0)
	var UPPER  = 'A'.charCodeAt(0)
	var PLUS_URL_SAFE = '-'.charCodeAt(0)
	var SLASH_URL_SAFE = '_'.charCodeAt(0)

	function decode (elt) {
		var code = elt.charCodeAt(0)
		if (code === PLUS ||
		    code === PLUS_URL_SAFE)
			return 62 // '+'
		if (code === SLASH ||
		    code === SLASH_URL_SAFE)
			return 63 // '/'
		if (code < NUMBER)
			return -1 //no match
		if (code < NUMBER + 10)
			return code - NUMBER + 26 + 26
		if (code < UPPER + 26)
			return code - UPPER
		if (code < LOWER + 26)
			return code - LOWER + 26
	}

	function b64ToByteArray (b64) {
		var i, j, l, tmp, placeHolders, arr

		if (b64.length % 4 > 0) {
			throw new Error('Invalid string. Length must be a multiple of 4')
		}

		// the number of equal signs (place holders)
		// if there are two placeholders, than the two characters before it
		// represent one byte
		// if there is only one, then the three characters before it represent 2 bytes
		// this is just a cheap hack to not do indexOf twice
		var len = b64.length
		placeHolders = '=' === b64.charAt(len - 2) ? 2 : '=' === b64.charAt(len - 1) ? 1 : 0

		// base64 is 4/3 + up to two characters of the original data
		arr = new Arr(b64.length * 3 / 4 - placeHolders)

		// if there are placeholders, only get up to the last complete 4 chars
		l = placeHolders > 0 ? b64.length - 4 : b64.length

		var L = 0

		function push (v) {
			arr[L++] = v
		}

		for (i = 0, j = 0; i < l; i += 4, j += 3) {
			tmp = (decode(b64.charAt(i)) << 18) | (decode(b64.charAt(i + 1)) << 12) | (decode(b64.charAt(i + 2)) << 6) | decode(b64.charAt(i + 3))
			push((tmp & 0xFF0000) >> 16)
			push((tmp & 0xFF00) >> 8)
			push(tmp & 0xFF)
		}

		if (placeHolders === 2) {
			tmp = (decode(b64.charAt(i)) << 2) | (decode(b64.charAt(i + 1)) >> 4)
			push(tmp & 0xFF)
		} else if (placeHolders === 1) {
			tmp = (decode(b64.charAt(i)) << 10) | (decode(b64.charAt(i + 1)) << 4) | (decode(b64.charAt(i + 2)) >> 2)
			push((tmp >> 8) & 0xFF)
			push(tmp & 0xFF)
		}

		return arr
	}

	function uint8ToBase64 (uint8) {
		var i,
			extraBytes = uint8.length % 3, // if we have 1 byte left, pad 2 bytes
			output = "",
			temp, length

		function encode (num) {
			return lookup.charAt(num)
		}

		function tripletToBase64 (num) {
			return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F)
		}

		// go through the array every three bytes, we'll deal with trailing stuff later
		for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
			temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
			output += tripletToBase64(temp)
		}

		// pad the end with zeros, but make sure to not forget the extra bytes
		switch (extraBytes) {
			case 1:
				temp = uint8[uint8.length - 1]
				output += encode(temp >> 2)
				output += encode((temp << 4) & 0x3F)
				output += '=='
				break
			case 2:
				temp = (uint8[uint8.length - 2] << 8) + (uint8[uint8.length - 1])
				output += encode(temp >> 10)
				output += encode((temp >> 4) & 0x3F)
				output += encode((temp << 2) & 0x3F)
				output += '='
				break
		}

		return output
	}

	exports.toByteArray = b64ToByteArray
	exports.fromByteArray = uint8ToBase64
}(typeof exports === 'undefined' ? (this.base64js = {}) : exports))

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../../node_modules/base64-js/lib/b64.js","/../../node_modules/base64-js/lib")
},{"buffer":11,"rH1JPG":13}],11:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

var base64 = require('base64-js')
var ieee754 = require('ieee754')

exports.Buffer = Buffer
exports.SlowBuffer = Buffer
exports.INSPECT_MAX_BYTES = 50
Buffer.poolSize = 8192

/**
 * If `Buffer._useTypedArrays`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (compatible down to IE6)
 */
Buffer._useTypedArrays = (function () {
  // Detect if browser supports Typed Arrays. Supported browsers are IE 10+, Firefox 4+,
  // Chrome 7+, Safari 5.1+, Opera 11.6+, iOS 4.2+. If the browser does not support adding
  // properties to `Uint8Array` instances, then that's the same as no `Uint8Array` support
  // because we need to be able to add all the node Buffer API methods. This is an issue
  // in Firefox 4-29. Now fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=695438
  try {
    var buf = new ArrayBuffer(0)
    var arr = new Uint8Array(buf)
    arr.foo = function () { return 42 }
    return 42 === arr.foo() &&
        typeof arr.subarray === 'function' // Chrome 9-10 lack `subarray`
  } catch (e) {
    return false
  }
})()

/**
 * Class: Buffer
 * =============
 *
 * The Buffer constructor returns instances of `Uint8Array` that are augmented
 * with function properties for all the node `Buffer` API functions. We use
 * `Uint8Array` so that square bracket notation works as expected -- it returns
 * a single octet.
 *
 * By augmenting the instances, we can avoid modifying the `Uint8Array`
 * prototype.
 */
function Buffer (subject, encoding, noZero) {
  if (!(this instanceof Buffer))
    return new Buffer(subject, encoding, noZero)

  var type = typeof subject

  // Workaround: node's base64 implementation allows for non-padded strings
  // while base64-js does not.
  if (encoding === 'base64' && type === 'string') {
    subject = stringtrim(subject)
    while (subject.length % 4 !== 0) {
      subject = subject + '='
    }
  }

  // Find the length
  var length
  if (type === 'number')
    length = coerce(subject)
  else if (type === 'string')
    length = Buffer.byteLength(subject, encoding)
  else if (type === 'object')
    length = coerce(subject.length) // assume that object is array-like
  else
    throw new Error('First argument needs to be a number, array or string.')

  var buf
  if (Buffer._useTypedArrays) {
    // Preferred: Return an augmented `Uint8Array` instance for best performance
    buf = Buffer._augment(new Uint8Array(length))
  } else {
    // Fallback: Return THIS instance of Buffer (created by `new`)
    buf = this
    buf.length = length
    buf._isBuffer = true
  }

  var i
  if (Buffer._useTypedArrays && typeof subject.byteLength === 'number') {
    // Speed optimization -- use set if we're copying from a typed array
    buf._set(subject)
  } else if (isArrayish(subject)) {
    // Treat array-ish objects as a byte array
    for (i = 0; i < length; i++) {
      if (Buffer.isBuffer(subject))
        buf[i] = subject.readUInt8(i)
      else
        buf[i] = subject[i]
    }
  } else if (type === 'string') {
    buf.write(subject, 0, encoding)
  } else if (type === 'number' && !Buffer._useTypedArrays && !noZero) {
    for (i = 0; i < length; i++) {
      buf[i] = 0
    }
  }

  return buf
}

// STATIC METHODS
// ==============

Buffer.isEncoding = function (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'binary':
    case 'base64':
    case 'raw':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.isBuffer = function (b) {
  return !!(b !== null && b !== undefined && b._isBuffer)
}

Buffer.byteLength = function (str, encoding) {
  var ret
  str = str + ''
  switch (encoding || 'utf8') {
    case 'hex':
      ret = str.length / 2
      break
    case 'utf8':
    case 'utf-8':
      ret = utf8ToBytes(str).length
      break
    case 'ascii':
    case 'binary':
    case 'raw':
      ret = str.length
      break
    case 'base64':
      ret = base64ToBytes(str).length
      break
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      ret = str.length * 2
      break
    default:
      throw new Error('Unknown encoding')
  }
  return ret
}

Buffer.concat = function (list, totalLength) {
  assert(isArray(list), 'Usage: Buffer.concat(list, [totalLength])\n' +
      'list should be an Array.')

  if (list.length === 0) {
    return new Buffer(0)
  } else if (list.length === 1) {
    return list[0]
  }

  var i
  if (typeof totalLength !== 'number') {
    totalLength = 0
    for (i = 0; i < list.length; i++) {
      totalLength += list[i].length
    }
  }

  var buf = new Buffer(totalLength)
  var pos = 0
  for (i = 0; i < list.length; i++) {
    var item = list[i]
    item.copy(buf, pos)
    pos += item.length
  }
  return buf
}

// BUFFER INSTANCE METHODS
// =======================

function _hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  assert(strLen % 2 === 0, 'Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; i++) {
    var byte = parseInt(string.substr(i * 2, 2), 16)
    assert(!isNaN(byte), 'Invalid hex string')
    buf[offset + i] = byte
  }
  Buffer._charsWritten = i * 2
  return i
}

function _utf8Write (buf, string, offset, length) {
  var charsWritten = Buffer._charsWritten =
    blitBuffer(utf8ToBytes(string), buf, offset, length)
  return charsWritten
}

function _asciiWrite (buf, string, offset, length) {
  var charsWritten = Buffer._charsWritten =
    blitBuffer(asciiToBytes(string), buf, offset, length)
  return charsWritten
}

function _binaryWrite (buf, string, offset, length) {
  return _asciiWrite(buf, string, offset, length)
}

function _base64Write (buf, string, offset, length) {
  var charsWritten = Buffer._charsWritten =
    blitBuffer(base64ToBytes(string), buf, offset, length)
  return charsWritten
}

function _utf16leWrite (buf, string, offset, length) {
  var charsWritten = Buffer._charsWritten =
    blitBuffer(utf16leToBytes(string), buf, offset, length)
  return charsWritten
}

Buffer.prototype.write = function (string, offset, length, encoding) {
  // Support both (string, offset, length, encoding)
  // and the legacy (string, encoding, offset, length)
  if (isFinite(offset)) {
    if (!isFinite(length)) {
      encoding = length
      length = undefined
    }
  } else {  // legacy
    var swap = encoding
    encoding = offset
    offset = length
    length = swap
  }

  offset = Number(offset) || 0
  var remaining = this.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }
  encoding = String(encoding || 'utf8').toLowerCase()

  var ret
  switch (encoding) {
    case 'hex':
      ret = _hexWrite(this, string, offset, length)
      break
    case 'utf8':
    case 'utf-8':
      ret = _utf8Write(this, string, offset, length)
      break
    case 'ascii':
      ret = _asciiWrite(this, string, offset, length)
      break
    case 'binary':
      ret = _binaryWrite(this, string, offset, length)
      break
    case 'base64':
      ret = _base64Write(this, string, offset, length)
      break
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      ret = _utf16leWrite(this, string, offset, length)
      break
    default:
      throw new Error('Unknown encoding')
  }
  return ret
}

Buffer.prototype.toString = function (encoding, start, end) {
  var self = this

  encoding = String(encoding || 'utf8').toLowerCase()
  start = Number(start) || 0
  end = (end !== undefined)
    ? Number(end)
    : end = self.length

  // Fastpath empty strings
  if (end === start)
    return ''

  var ret
  switch (encoding) {
    case 'hex':
      ret = _hexSlice(self, start, end)
      break
    case 'utf8':
    case 'utf-8':
      ret = _utf8Slice(self, start, end)
      break
    case 'ascii':
      ret = _asciiSlice(self, start, end)
      break
    case 'binary':
      ret = _binarySlice(self, start, end)
      break
    case 'base64':
      ret = _base64Slice(self, start, end)
      break
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      ret = _utf16leSlice(self, start, end)
      break
    default:
      throw new Error('Unknown encoding')
  }
  return ret
}

Buffer.prototype.toJSON = function () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function (target, target_start, start, end) {
  var source = this

  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (!target_start) target_start = 0

  // Copy 0 bytes; we're done
  if (end === start) return
  if (target.length === 0 || source.length === 0) return

  // Fatal error conditions
  assert(end >= start, 'sourceEnd < sourceStart')
  assert(target_start >= 0 && target_start < target.length,
      'targetStart out of bounds')
  assert(start >= 0 && start < source.length, 'sourceStart out of bounds')
  assert(end >= 0 && end <= source.length, 'sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length)
    end = this.length
  if (target.length - target_start < end - start)
    end = target.length - target_start + start

  var len = end - start

  if (len < 100 || !Buffer._useTypedArrays) {
    for (var i = 0; i < len; i++)
      target[i + target_start] = this[i + start]
  } else {
    target._set(this.subarray(start, start + len), target_start)
  }
}

function _base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function _utf8Slice (buf, start, end) {
  var res = ''
  var tmp = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; i++) {
    if (buf[i] <= 0x7F) {
      res += decodeUtf8Char(tmp) + String.fromCharCode(buf[i])
      tmp = ''
    } else {
      tmp += '%' + buf[i].toString(16)
    }
  }

  return res + decodeUtf8Char(tmp)
}

function _asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; i++)
    ret += String.fromCharCode(buf[i])
  return ret
}

function _binarySlice (buf, start, end) {
  return _asciiSlice(buf, start, end)
}

function _hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; i++) {
    out += toHex(buf[i])
  }
  return out
}

function _utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i+1] * 256)
  }
  return res
}

Buffer.prototype.slice = function (start, end) {
  var len = this.length
  start = clamp(start, len, 0)
  end = clamp(end, len, len)

  if (Buffer._useTypedArrays) {
    return Buffer._augment(this.subarray(start, end))
  } else {
    var sliceLen = end - start
    var newBuf = new Buffer(sliceLen, undefined, true)
    for (var i = 0; i < sliceLen; i++) {
      newBuf[i] = this[i + start]
    }
    return newBuf
  }
}

// `get` will be removed in Node 0.13+
Buffer.prototype.get = function (offset) {
  console.log('.get() is deprecated. Access using array indexes instead.')
  return this.readUInt8(offset)
}

// `set` will be removed in Node 0.13+
Buffer.prototype.set = function (v, offset) {
  console.log('.set() is deprecated. Access using array indexes instead.')
  return this.writeUInt8(v, offset)
}

Buffer.prototype.readUInt8 = function (offset, noAssert) {
  if (!noAssert) {
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset < this.length, 'Trying to read beyond buffer length')
  }

  if (offset >= this.length)
    return

  return this[offset]
}

function _readUInt16 (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 1 < buf.length, 'Trying to read beyond buffer length')
  }

  var len = buf.length
  if (offset >= len)
    return

  var val
  if (littleEndian) {
    val = buf[offset]
    if (offset + 1 < len)
      val |= buf[offset + 1] << 8
  } else {
    val = buf[offset] << 8
    if (offset + 1 < len)
      val |= buf[offset + 1]
  }
  return val
}

Buffer.prototype.readUInt16LE = function (offset, noAssert) {
  return _readUInt16(this, offset, true, noAssert)
}

Buffer.prototype.readUInt16BE = function (offset, noAssert) {
  return _readUInt16(this, offset, false, noAssert)
}

function _readUInt32 (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'Trying to read beyond buffer length')
  }

  var len = buf.length
  if (offset >= len)
    return

  var val
  if (littleEndian) {
    if (offset + 2 < len)
      val = buf[offset + 2] << 16
    if (offset + 1 < len)
      val |= buf[offset + 1] << 8
    val |= buf[offset]
    if (offset + 3 < len)
      val = val + (buf[offset + 3] << 24 >>> 0)
  } else {
    if (offset + 1 < len)
      val = buf[offset + 1] << 16
    if (offset + 2 < len)
      val |= buf[offset + 2] << 8
    if (offset + 3 < len)
      val |= buf[offset + 3]
    val = val + (buf[offset] << 24 >>> 0)
  }
  return val
}

Buffer.prototype.readUInt32LE = function (offset, noAssert) {
  return _readUInt32(this, offset, true, noAssert)
}

Buffer.prototype.readUInt32BE = function (offset, noAssert) {
  return _readUInt32(this, offset, false, noAssert)
}

Buffer.prototype.readInt8 = function (offset, noAssert) {
  if (!noAssert) {
    assert(offset !== undefined && offset !== null,
        'missing offset')
    assert(offset < this.length, 'Trying to read beyond buffer length')
  }

  if (offset >= this.length)
    return

  var neg = this[offset] & 0x80
  if (neg)
    return (0xff - this[offset] + 1) * -1
  else
    return this[offset]
}

function _readInt16 (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 1 < buf.length, 'Trying to read beyond buffer length')
  }

  var len = buf.length
  if (offset >= len)
    return

  var val = _readUInt16(buf, offset, littleEndian, true)
  var neg = val & 0x8000
  if (neg)
    return (0xffff - val + 1) * -1
  else
    return val
}

Buffer.prototype.readInt16LE = function (offset, noAssert) {
  return _readInt16(this, offset, true, noAssert)
}

Buffer.prototype.readInt16BE = function (offset, noAssert) {
  return _readInt16(this, offset, false, noAssert)
}

function _readInt32 (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'Trying to read beyond buffer length')
  }

  var len = buf.length
  if (offset >= len)
    return

  var val = _readUInt32(buf, offset, littleEndian, true)
  var neg = val & 0x80000000
  if (neg)
    return (0xffffffff - val + 1) * -1
  else
    return val
}

Buffer.prototype.readInt32LE = function (offset, noAssert) {
  return _readInt32(this, offset, true, noAssert)
}

Buffer.prototype.readInt32BE = function (offset, noAssert) {
  return _readInt32(this, offset, false, noAssert)
}

function _readFloat (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset + 3 < buf.length, 'Trying to read beyond buffer length')
  }

  return ieee754.read(buf, offset, littleEndian, 23, 4)
}

Buffer.prototype.readFloatLE = function (offset, noAssert) {
  return _readFloat(this, offset, true, noAssert)
}

Buffer.prototype.readFloatBE = function (offset, noAssert) {
  return _readFloat(this, offset, false, noAssert)
}

function _readDouble (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset + 7 < buf.length, 'Trying to read beyond buffer length')
  }

  return ieee754.read(buf, offset, littleEndian, 52, 8)
}

Buffer.prototype.readDoubleLE = function (offset, noAssert) {
  return _readDouble(this, offset, true, noAssert)
}

Buffer.prototype.readDoubleBE = function (offset, noAssert) {
  return _readDouble(this, offset, false, noAssert)
}

Buffer.prototype.writeUInt8 = function (value, offset, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset < this.length, 'trying to write beyond buffer length')
    verifuint(value, 0xff)
  }

  if (offset >= this.length) return

  this[offset] = value
}

function _writeUInt16 (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 1 < buf.length, 'trying to write beyond buffer length')
    verifuint(value, 0xffff)
  }

  var len = buf.length
  if (offset >= len)
    return

  for (var i = 0, j = Math.min(len - offset, 2); i < j; i++) {
    buf[offset + i] =
        (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
            (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function (value, offset, noAssert) {
  _writeUInt16(this, value, offset, true, noAssert)
}

Buffer.prototype.writeUInt16BE = function (value, offset, noAssert) {
  _writeUInt16(this, value, offset, false, noAssert)
}

function _writeUInt32 (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'trying to write beyond buffer length')
    verifuint(value, 0xffffffff)
  }

  var len = buf.length
  if (offset >= len)
    return

  for (var i = 0, j = Math.min(len - offset, 4); i < j; i++) {
    buf[offset + i] =
        (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function (value, offset, noAssert) {
  _writeUInt32(this, value, offset, true, noAssert)
}

Buffer.prototype.writeUInt32BE = function (value, offset, noAssert) {
  _writeUInt32(this, value, offset, false, noAssert)
}

Buffer.prototype.writeInt8 = function (value, offset, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset < this.length, 'Trying to write beyond buffer length')
    verifsint(value, 0x7f, -0x80)
  }

  if (offset >= this.length)
    return

  if (value >= 0)
    this.writeUInt8(value, offset, noAssert)
  else
    this.writeUInt8(0xff + value + 1, offset, noAssert)
}

function _writeInt16 (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 1 < buf.length, 'Trying to write beyond buffer length')
    verifsint(value, 0x7fff, -0x8000)
  }

  var len = buf.length
  if (offset >= len)
    return

  if (value >= 0)
    _writeUInt16(buf, value, offset, littleEndian, noAssert)
  else
    _writeUInt16(buf, 0xffff + value + 1, offset, littleEndian, noAssert)
}

Buffer.prototype.writeInt16LE = function (value, offset, noAssert) {
  _writeInt16(this, value, offset, true, noAssert)
}

Buffer.prototype.writeInt16BE = function (value, offset, noAssert) {
  _writeInt16(this, value, offset, false, noAssert)
}

function _writeInt32 (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'Trying to write beyond buffer length')
    verifsint(value, 0x7fffffff, -0x80000000)
  }

  var len = buf.length
  if (offset >= len)
    return

  if (value >= 0)
    _writeUInt32(buf, value, offset, littleEndian, noAssert)
  else
    _writeUInt32(buf, 0xffffffff + value + 1, offset, littleEndian, noAssert)
}

Buffer.prototype.writeInt32LE = function (value, offset, noAssert) {
  _writeInt32(this, value, offset, true, noAssert)
}

Buffer.prototype.writeInt32BE = function (value, offset, noAssert) {
  _writeInt32(this, value, offset, false, noAssert)
}

function _writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'Trying to write beyond buffer length')
    verifIEEE754(value, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }

  var len = buf.length
  if (offset >= len)
    return

  ieee754.write(buf, value, offset, littleEndian, 23, 4)
}

Buffer.prototype.writeFloatLE = function (value, offset, noAssert) {
  _writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function (value, offset, noAssert) {
  _writeFloat(this, value, offset, false, noAssert)
}

function _writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 7 < buf.length,
        'Trying to write beyond buffer length')
    verifIEEE754(value, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }

  var len = buf.length
  if (offset >= len)
    return

  ieee754.write(buf, value, offset, littleEndian, 52, 8)
}

Buffer.prototype.writeDoubleLE = function (value, offset, noAssert) {
  _writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function (value, offset, noAssert) {
  _writeDouble(this, value, offset, false, noAssert)
}

// fill(value, start=0, end=buffer.length)
Buffer.prototype.fill = function (value, start, end) {
  if (!value) value = 0
  if (!start) start = 0
  if (!end) end = this.length

  if (typeof value === 'string') {
    value = value.charCodeAt(0)
  }

  assert(typeof value === 'number' && !isNaN(value), 'value is not a number')
  assert(end >= start, 'end < start')

  // Fill 0 bytes; we're done
  if (end === start) return
  if (this.length === 0) return

  assert(start >= 0 && start < this.length, 'start out of bounds')
  assert(end >= 0 && end <= this.length, 'end out of bounds')

  for (var i = start; i < end; i++) {
    this[i] = value
  }
}

Buffer.prototype.inspect = function () {
  var out = []
  var len = this.length
  for (var i = 0; i < len; i++) {
    out[i] = toHex(this[i])
    if (i === exports.INSPECT_MAX_BYTES) {
      out[i + 1] = '...'
      break
    }
  }
  return '<Buffer ' + out.join(' ') + '>'
}

/**
 * Creates a new `ArrayBuffer` with the *copied* memory of the buffer instance.
 * Added in Node 0.12. Only available in browsers that support ArrayBuffer.
 */
Buffer.prototype.toArrayBuffer = function () {
  if (typeof Uint8Array !== 'undefined') {
    if (Buffer._useTypedArrays) {
      return (new Buffer(this)).buffer
    } else {
      var buf = new Uint8Array(this.length)
      for (var i = 0, len = buf.length; i < len; i += 1)
        buf[i] = this[i]
      return buf.buffer
    }
  } else {
    throw new Error('Buffer.toArrayBuffer not supported in this browser')
  }
}

// HELPER FUNCTIONS
// ================

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

var BP = Buffer.prototype

/**
 * Augment a Uint8Array *instance* (not the Uint8Array class!) with Buffer methods
 */
Buffer._augment = function (arr) {
  arr._isBuffer = true

  // save reference to original Uint8Array get/set methods before overwriting
  arr._get = arr.get
  arr._set = arr.set

  // deprecated, will be removed in node 0.13+
  arr.get = BP.get
  arr.set = BP.set

  arr.write = BP.write
  arr.toString = BP.toString
  arr.toLocaleString = BP.toString
  arr.toJSON = BP.toJSON
  arr.copy = BP.copy
  arr.slice = BP.slice
  arr.readUInt8 = BP.readUInt8
  arr.readUInt16LE = BP.readUInt16LE
  arr.readUInt16BE = BP.readUInt16BE
  arr.readUInt32LE = BP.readUInt32LE
  arr.readUInt32BE = BP.readUInt32BE
  arr.readInt8 = BP.readInt8
  arr.readInt16LE = BP.readInt16LE
  arr.readInt16BE = BP.readInt16BE
  arr.readInt32LE = BP.readInt32LE
  arr.readInt32BE = BP.readInt32BE
  arr.readFloatLE = BP.readFloatLE
  arr.readFloatBE = BP.readFloatBE
  arr.readDoubleLE = BP.readDoubleLE
  arr.readDoubleBE = BP.readDoubleBE
  arr.writeUInt8 = BP.writeUInt8
  arr.writeUInt16LE = BP.writeUInt16LE
  arr.writeUInt16BE = BP.writeUInt16BE
  arr.writeUInt32LE = BP.writeUInt32LE
  arr.writeUInt32BE = BP.writeUInt32BE
  arr.writeInt8 = BP.writeInt8
  arr.writeInt16LE = BP.writeInt16LE
  arr.writeInt16BE = BP.writeInt16BE
  arr.writeInt32LE = BP.writeInt32LE
  arr.writeInt32BE = BP.writeInt32BE
  arr.writeFloatLE = BP.writeFloatLE
  arr.writeFloatBE = BP.writeFloatBE
  arr.writeDoubleLE = BP.writeDoubleLE
  arr.writeDoubleBE = BP.writeDoubleBE
  arr.fill = BP.fill
  arr.inspect = BP.inspect
  arr.toArrayBuffer = BP.toArrayBuffer

  return arr
}

// slice(start, end)
function clamp (index, len, defaultValue) {
  if (typeof index !== 'number') return defaultValue
  index = ~~index;  // Coerce to integer.
  if (index >= len) return len
  if (index >= 0) return index
  index += len
  if (index >= 0) return index
  return 0
}

function coerce (length) {
  // Coerce length to a number (possibly NaN), round up
  // in case it's fractional (e.g. 123.456) then do a
  // double negate to coerce a NaN to 0. Easy, right?
  length = ~~Math.ceil(+length)
  return length < 0 ? 0 : length
}

function isArray (subject) {
  return (Array.isArray || function (subject) {
    return Object.prototype.toString.call(subject) === '[object Array]'
  })(subject)
}

function isArrayish (subject) {
  return isArray(subject) || Buffer.isBuffer(subject) ||
      subject && typeof subject === 'object' &&
      typeof subject.length === 'number'
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    var b = str.charCodeAt(i)
    if (b <= 0x7F)
      byteArray.push(str.charCodeAt(i))
    else {
      var start = i
      if (b >= 0xD800 && b <= 0xDFFF) i++
      var h = encodeURIComponent(str.slice(start, i+1)).substr(1).split('%')
      for (var j = 0; j < h.length; j++)
        byteArray.push(parseInt(h[j], 16))
    }
  }
  return byteArray
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(str)
}

function blitBuffer (src, dst, offset, length) {
  var pos
  for (var i = 0; i < length; i++) {
    if ((i + offset >= dst.length) || (i >= src.length))
      break
    dst[i + offset] = src[i]
  }
  return i
}

function decodeUtf8Char (str) {
  try {
    return decodeURIComponent(str)
  } catch (err) {
    return String.fromCharCode(0xFFFD) // UTF 8 invalid char
  }
}

/*
 * We have to make sure that the value is a valid integer. This means that it
 * is non-negative. It has no fractional component and that it does not
 * exceed the maximum allowed value.
 */
function verifuint (value, max) {
  assert(typeof value === 'number', 'cannot write a non-number as a number')
  assert(value >= 0, 'specified a negative value for writing an unsigned value')
  assert(value <= max, 'value is larger than maximum value for type')
  assert(Math.floor(value) === value, 'value has a fractional component')
}

function verifsint (value, max, min) {
  assert(typeof value === 'number', 'cannot write a non-number as a number')
  assert(value <= max, 'value larger than maximum allowed value')
  assert(value >= min, 'value smaller than minimum allowed value')
  assert(Math.floor(value) === value, 'value has a fractional component')
}

function verifIEEE754 (value, max, min) {
  assert(typeof value === 'number', 'cannot write a non-number as a number')
  assert(value <= max, 'value larger than maximum allowed value')
  assert(value >= min, 'value smaller than minimum allowed value')
}

function assert (test, message) {
  if (!test) throw new Error(message || 'Failed assertion')
}

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../../node_modules/buffer/index.js","/../../node_modules/buffer")
},{"base64-js":10,"buffer":11,"ieee754":12,"rH1JPG":13}],12:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../../node_modules/ieee754/index.js","/../../node_modules/ieee754")
},{"buffer":11,"rH1JPG":13}],13:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// shim for using process in browser

var process = module.exports = {};

process.nextTick = (function () {
    var canSetImmediate = typeof window !== 'undefined'
    && window.setImmediate;
    var canPost = typeof window !== 'undefined'
    && window.postMessage && window.addEventListener
    ;

    if (canSetImmediate) {
        return function (f) { return window.setImmediate(f) };
    }

    if (canPost) {
        var queue = [];
        window.addEventListener('message', function (ev) {
            var source = ev.source;
            if ((source === window || source === null) && ev.data === 'process-tick') {
                ev.stopPropagation();
                if (queue.length > 0) {
                    var fn = queue.shift();
                    fn();
                }
            }
        }, true);

        return function nextTick(fn) {
            queue.push(fn);
            window.postMessage('process-tick', '*');
        };
    }

    return function nextTick(fn) {
        setTimeout(fn, 0);
    };
})();

process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
}

// TODO(shtylman)
process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../../node_modules/process/browser.js","/../../node_modules/process")
},{"buffer":11,"rH1JPG":13}]},{},[1])